import { enumeration } from '@dazn/peng-html5-tools-utils';
var MediaType = enumeration(['VOD', 'LIVE', 'LINEAR', 'NONE']);
export { MediaType };
//# sourceMappingURL=MediaType.js.map